module.exports = __webpack_public_path__ + "static/media/bg-squiggle-alt.d82e69aa.png";